module.exports = __webpack_public_path__ + "img/TAM4000_R.c53adca7.png";